import React, {useState} from "react";
import useModal from "components/modal/useModal";
import Modalheader from "components/modal/components/header";
import ModalBody from "components/modal/components/body";
import { Import, Warning } from "assets/icons";
import ModalFooter from "components/modal/components/footer";
import Button from "components/button";
import axios from "axios";
import { toast } from "react-toastify";
import Divider from "components/divider/divider";
import Banner from "components/banner/banner";
import usefetchdata from "hooks/usefetchdata";
import UseContext from "hooks/useContext";
import LoadingButton from "components/button/loading.js";
import CheckFilesIdentity from "../identity/components/body/checkFilesIdentity";

const Cardvitale = () => {
    const { toggle } = useModal();
    const { tempWorkerData } = usefetchdata();
    const { refreshLoadWorker, language } = UseContext();
    const [singleFile, setSingleFile] = useState("");
    const [titleFile, setTitleFile] = useState("");
    const [loading, setLoading] = useState(false);
    const [vitalType, setVitalType] = useState("");
    const [formIndex, setFormIndex] = useState(1);
    const token = localStorage.getItem("xsrfToken");

    const handlerSingleFile = (e) => {
        setSingleFile(e.target.files[0]);
        setTitleFile(e.target.files[0].name);
    };

    const singleUpload = async (data) => {
        try {
            await axios
                .post(
                    `${process.env.REACT_APP_API_URL}upload/files`,
                    data
                )
                .then((res) => {
                    if (res.data) {
                        toast.success("La carte vitale a été ajoutée");
                        refreshLoadWorker();
                        setTitleFile("");
                        toggle();
                    }
                    if (res.errors) {
                        toast.error("Une erreur est survenu");
                        setTitleFile("");
                    }
                })
                .catch((e) => {
                    setLoading(false);
                    toast.error("Une erreur est survenu");
                    setTimeout(() => {
                        setTitleFile("");
                    }, 3000);
                })
                .finally(() => {
                    setLoading(false);
                });
        } catch (e) {
            console.log(e);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if(vitalType && singleFile){
            setLoading(true);
                const formData = new FormData();
                formData.append("vitale", singleFile);
                formData.append("token", token);
            formData.append("vitalType", vitalType);
                await singleUpload(formData);
        } else {
            toast.error("Veuillez renseigner le type de document et la carte vitale.");
        }
    };

    const handleNext = () => {
        if (formIndex === 1) {
            if (!vitalType) {
                toast.error("Veuillez sélectionner le type de document.");
                return;
            }
            if (!singleFile) {
                toast.error("Veuillez ajouter la carte vitale.");
                return;
            }
        }
        setFormIndex(formIndex + 1)
    }

    return (
        <>
            <Modalheader hide={toggle} hideShow={true}>
                {tempWorkerData?.card_vitality?.validated === "1"
                    ? language.getValue("justify.m_vitale_title_u")
                    : language.getValue("justify.m_vitale_title_c")}
            </Modalheader>
            <ModalBody>
                {
                    formIndex === 1 ? (
                        <>
                            {tempWorkerData?.card_vitality?.validated === "1" ? (
                                <Banner type={"warning"}>
                                    Un document est déjà en cours d’observation, la modification reste possible.
                                </Banner>
                            ) : (
                                ""
                            )}
                            <p className="ft-sm text-gray-500 my-3">
                                Critères de validation du document :
                            </p>
                            <span className="flex  gap-2 items-center">
                                <Warning wh={17} color={"#EF4444"} />
                                Le document doit être de bonne qualité
                            </span>
                            <div className={'my-3'}>
                                <Divider w={100}/>
                            </div>
                            <span className="flex  gap-2 items-center">
                                <Warning wh={17} color={"#EF4444"} />
                                Les informations doivent être lisibles
                            </span>
                            <div className={'my-3'}>
                                <Divider w={100}/>
                            </div>
                            <div className="flex flex-col w-full gap-2">
                                <form id="uploadForm" className="flex flex-col gap-3">
                                    <div>
                                        <label className={"ft-sm font-medium text-gray-500"}>
                                            Type de document
                                        </label>
                                        <select
                                            name="vitalType"
                                            id="vitalType"
                                            className="w-full h-10 pl-2 pr-3 ft-b placeholder-gray-600 border rounded-lg "
                                            onChange={(e) => setVitalType(e.target.value)}
                                            value={vitalType}
                                        >
                                            <option value="">Sélectionner</option>
                                            <option value="vital">Carte Vitale</option>
                                            <option value="cpam">Attestation CPAM</option>
                                        </select>
                                    </div>
                                    <label className="w-full flex flex-row  border border-gray-300 rounded-lg h-11 shadow-sm">
                                        <div className="ft-sm text-gray-700 w-1/4 p-4 flex items-center justify-center gap-2 border-r border-gray-300">
                                            <Import color={"#374151"} wh={14} />
                                            Importer
                                        </div>
                                        <div className="ft-sm truncate overflow-hidden  text-gray-400 flex items-center ml-3">
                                            {titleFile ? titleFile : "Aucun fichier"}
                                        </div>

                                        <input
                                            type="file"
                                            id="file"
                                            accept="image/jpeg,image/jpg,application/pdf"
                                            className="hidden"
                                            onChange={(e) => handlerSingleFile(e)}
                                        />
                                    </label>

                                    <span className="ft-xs text-gray-400">
                                        Format acceptées : PDF, JPG (5Mo max)
                                    </span>
                                </form>
                            </div>
                        </>
                    ) : (
                        <>
                            <CheckFilesIdentity key={CheckFilesIdentity} files={[singleFile]} />
                        </>
                    )
                }
            </ModalBody>
            <ModalFooter>
                {loading ? (
                    <LoadingButton size={"LG"} />
                ) : (
                    <>
                    {
                        formIndex === 1 ? (
                            <>
                                <Button
                                    size={"LG"}
                                    color={"SECONDARY"}
                                    onClick={toggle}
                                >
                                    Annuler
                                </Button>
                                <Button size={"LG"} onClick={() => handleNext()}>
                                    Suivant
                                </Button>
                            </>
                        ) : (
                            <>
                                <Button
                                    size={"LG"}
                                    color={"SECONDARY"}
                                    onClick={() => setFormIndex(formIndex - 1)}
                                >
                                    Précédent
                                </Button>
                                <Button size={"LG"} onClick={handleSubmit}>
                                    Confirmer
                                </Button>
                            </>
                        )
                    }
                    </>
                )}
            </ModalFooter>
        </>
    );
};

export default Cardvitale;
